import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@/helpers/common';
import { ScStaticPageLastUpdate } from '@/styles/common';
import type { DateLastUpdateStaticProps } from './types';

export const DateLastUpdateStatic: FC<DateLastUpdateStaticProps> = ({
  version,
  lastUpdated,
  effectiveFrom,
}) => {
  const { t } = useTranslation('common');

  return (
    <ScStaticPageLastUpdate>
      {effectiveFrom && (
        <p>
          {t('effectiveFrom')}: {formatDate(effectiveFrom, t, 'common:month')}
        </p>
      )}
      {lastUpdated && (
        <p>
          {version && `${t('version')} ${version} `}
          {t('lastUpdated')}: {formatDate(lastUpdated, t, 'common:month')}
        </p>
      )}
    </ScStaticPageLastUpdate>
  );
};
